<template>
  <div class="docker-server">
    <iframe id="iframeChild" ref="iframeDom" name="iframeChild" :src="url" frameborder="0" scrolling="auto"></iframe>
  </div>
</template>

<script>
import VueCookies from 'vue-cookies';
/* 
  发货单管理-生产：https://ewuliu-supplier.epec.com/#/order/loadingList?reportCode=epec_xbjfhd&type=1
  发货单管理-uat：https://dev-a-ewuliu-supplier.epec.com/#/order/loadingList?reportCode=epec_xbjfhd&type=1
*/

export default {
  name: 'EnquiryInvoice',
  data() {
    return {
      token: '',
      url: '',
    };
  },
  created() {
    const token = VueCookies.get('epecToken');
    console.log('token', token);
    this.url =
      process.env.NODE_ENV === 'production'
        ? `https://yyzx.epec.com/ewuliu//#/order/loadingList?reportCode=epec_xbjfhd&type=1`
        : `https://uat-yyzx.epec.com/ewuliu/#/order/loadingList?reportCode=epec_xbjfhd&type=1`;
  },
};
</script>

<style lang="scss" scoped>
/** iframe样式 */
#iframeChild {
  width: 100%;
  height: calc(100vh - 125px);
}
</style>
